import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
	status: any;
}

const FormResponseMessage: FC<Props> = ({ status }) => {
	const { t } = useTranslation('generalForm');
	if (status) {
		const info = status.success ? t('success') : t('error');
		const message = status.success ? t('successMessage') : t('errorMessage');
		return (
			<div>
				<h2>{info}</h2>
				<p>{message}</p>
			</div>
		);
	}
	return null;
};

export default FormResponseMessage;
